import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Card, CardContent } from '../components/ui/card';
import { AlertTriangle, FileSignature, ArrowRight, ShieldAlert } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ScadenzeHubPage() {
  const [counts, setCounts] = useState({ verifiche: 0, contratti: 0 });

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const [vRes, cRes] = await Promise.all([
          axios.get(`${API}/impianti/scadenza-verifica`).catch(() => ({ data: [] })),
          axios.get(`${API}/contratti`).catch(() => ({ data: [] })),
        ]);
        const oggi = new Date().toISOString().slice(0, 10);
        const limite = new Date(Date.now() + 60 * 86400000).toISOString().slice(0, 10);
        const daRinnovare = (cRes.data || []).filter((c) => !c.disdetta && (c.data_fine || '').slice(0, 10) <= limite).length;
        setCounts({
          verifiche: (vRes.data || []).length,
          contratti: daRinnovare,
        });
      } catch (e) {
        console.error('Errore caricamento contatori scadenze:', e);
      }
    };
    fetchCounts();
  }, []);

  const cards = [
    {
      to: '/verifiche-scadenza',
      label: 'Verifiche RT',
      desc: 'Impianti con verifica periodica in scadenza nei prossimi giorni',
      icon: AlertTriangle,
      count: counts.verifiche,
      color: 'amber',
      testid: 'hub-card-verifiche',
    },
    {
      to: '/contratti',
      label: 'Contratti',
      desc: 'Contratti di assistenza scaduti o in scadenza entro 60 giorni: rinnovi, pagamenti e disdette',
      icon: FileSignature,
      count: counts.contratti,
      color: 'cyan',
      testid: 'hub-card-contratti',
    },
  ];

  return (
    <div className="space-y-6" data-testid="scadenze-hub">
      <div className="flex items-start gap-3">
        <div className="h-12 w-12 rounded-md bg-amber-500/10 text-amber-600 flex items-center justify-center">
          <ShieldAlert className="h-6 w-6" />
        </div>
        <div>
          <h1 className="text-2xl font-black tracking-tight">Scadenze</h1>
          <p className="text-sm text-muted-foreground">Centro unificato per verifiche periodiche e contratti di assistenza</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {cards.map(c => {
          const Icon = c.icon;
          const colorMap = {
            amber: 'border-amber-500/40 bg-amber-500/5 text-amber-600',
            cyan: 'border-cyan-500/40 bg-cyan-500/5 text-cyan-600',
          };
          return (
            <Link to={c.to} key={c.to} data-testid={c.testid}>
              <Card className={`hover:shadow-lg transition-all hover:-translate-y-0.5 cursor-pointer border-l-4 ${colorMap[c.color]}`}>
                <CardContent className="p-5">
                  <div className="flex items-start justify-between mb-3">
                    <div className={`h-11 w-11 rounded-md bg-${c.color}-500/10 flex items-center justify-center`}>
                      <Icon className={`h-5 w-5 text-${c.color}-500`} />
                    </div>
                    <ArrowRight className="h-4 w-4 text-muted-foreground" />
                  </div>
                  <h3 className="font-bold text-lg tracking-tight">{c.label}</h3>
                  <p className="text-xs text-muted-foreground mt-1 mb-3">{c.desc}</p>
                  <div className="flex items-end gap-2">
                    <span className="text-3xl font-black tabular-nums">{c.count}</span>
                    <span className="text-xs text-muted-foreground mb-1.5">in coda</span>
                  </div>
                </CardContent>
              </Card>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
